import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { workExperienceFields } from '../../api/applicationData';

const WorkExperience = forwardRef(({ newApplicant, setNewApplicant }, ref) => {
  const [errors, setErrors] = useState({});

  useImperativeHandle(ref, () => ({
    validateForm: () => {
      const newErrors = {};
      workExperienceFields.forEach(({ key }) => {
        if (!newApplicant?.workExperience?.[key]?.trim()) {
          newErrors[key] = 'This field is required';
        }
      });
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    },
  }));

  const handleChange = (field, value) => {
    setNewApplicant((prev) => ({
      ...prev,
      workExperience: {
        ...prev.workExperience,
        [field]: value,
      },
    }));
    setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  return (
    <div className="space-y-6">
      <p className="text-md text-slate-500">Answer each question in detail.</p>
      {workExperienceFields.map(({ key, label }) => (
        <div key={key}>
          <label className="block text-md mb-1">
            {label} <span className="text-red-500">*</span>
          </label>
          {key === 'washer_dryer_info' || key === 'vehicle_info' ? (
            <input
              type="text"
              className={`form-input w-full bg-gray-100 rounded-md ${
                errors[key] ? 'border border-red-500' : ''
              }`}
              value={newApplicant?.workExperience?.[key] || ''}
              onChange={(e) => handleChange(key, e.target.value)}
            />
          ) : (
            <textarea
              className={`form-input w-full bg-gray-100 rounded-md min-h-[80px] ${
                errors[key] ? 'border border-red-500' : ''
              }`}
              value={newApplicant?.workExperience?.[key] || ''}
              onChange={(e) => handleChange(key, e.target.value)}
            />
          )}
          {errors[key] && (
            <div className="text-red-500 text-xs mt-1">{errors[key]}</div>
          )}
        </div>
      ))}
    </div>
  );
});

export default WorkExperience;
